module.exports = __webpack_public_path__ + "static/media/xgboost_logo.ea9b1f52.png";